module.exports = __webpack_public_path__ + "static/img/quizzort_btn.57b22cec.png";